module.exports = __webpack_public_path__ + "img/banner.89fbc152.png";